import { useEffect, useState } from "react";
import api from "../../api/axios";
import AppLayout from "../../layouts/AppLayout";
import SettingCard from "../../components/SettingCard";

function Stock() {
    const [list, setList] = useState([]);
    const [selectedCode, setSelectedCode] = useState(null);
    const [filterLog, setFilterLog] = useState(null);

    useEffect(() => { load(); }, []);

    const load = () => {
        api.get("/auto/search/candidate").then((res) => setList(res.data || []));
    };

    const showFilterLog = (stockCode) => {
        if (selectedCode === stockCode) {
            setSelectedCode(null);
            setFilterLog(null);
            return;
        }
        setSelectedCode(stockCode);
        setFilterLog(null);
        api.get(`/auto/search/candidate/${stockCode}/buy-filter`)
            .then((res) => setFilterLog(res.data && Object.keys(res.data).length ? res.data : null))
            .catch(() => setFilterLog(null));
    };

    const scoreColor = (score) => score >= 90 ? "#2ecc71" : score >= 80 ? "#3498db" : score >= 70 ? "#f39c12" : "#888";
    const star = (score) => score >= 90 ? "★★★★★" : score >= 80 ? "★★★★☆" : score >= 70 ? "★★★☆☆" : score >= 60 ? "★★☆☆☆" : "★☆☆☆☆";
    const filterSections = (detail, finalReason) => {
        let normalized = String(detail || "");
        if (!normalized.includes("\n\n") && normalized.includes("종합지표:")) {
            const [criteria, current] = normalized.split("종합지표:");
            normalized = `기준 조건\n${criteria.trim()}\n\n현재 값\n${current.trim().replace(/,\s*/g, "\n").replaceAll("=", ": ")}\n\n통과 여부\n${finalReason}: 미통과`;
        }
        return normalized.split("\n\n").map((section) => {
            const [title, ...lines] = section.split("\n");
            return { title, lines };
        });
    };

    return (
        <AppLayout title="추천종목" subTitle="모의투자 자동매매 후보">
            <SettingCard title={`추천 후보 (${list.length})`}>
                <div style={{ fontSize: 13, color: "#888" }}>카드를 누르면 현재 매수 필터 판단을 확인할 수 있습니다.</div>
            </SettingCard>

            {list.map((item, index) => (
                <SettingCard key={item.stockCode} onClick={() => showFilterLog(item.stockCode)} title={`${index + 1}위 ${item.stockName}`}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div>
                            <div style={{ fontSize: 13, color: "#888" }}>{item.stockCode}</div>
                            <div style={{ marginTop: 6, color: "#777", fontSize: 13, lineHeight: 1.45 }}>{item.reason}</div>
                        </div>
                        <div style={{ textAlign: "right" }}>
                            <div style={{ fontWeight: "bold", fontSize: 24, color: scoreColor(item.score) }}>{item.score}</div>
                            <div style={{ color: "#f1c40f", fontSize: 14 }}>{star(item.score)}</div>
                        </div>
                    </div>

                    {selectedCode === item.stockCode && filterLog?.status === "REJECTED" && (
                        <div style={{ marginTop: 16, paddingTop: 14, borderTop: "1px solid var(--input-border)", display: "grid", gap: 14 }}>
                            <div>
                                <strong>매수 필터 결과</strong>
                                <div style={{ marginTop: 7, color: "#f59e0b", fontWeight: 700 }}>{filterLog.finalReason}</div>
                            </div>
                                {filterSections(filterLog.filterDetail, filterLog.finalReason).map((section) => (
                                <div key={section.title} style={{ padding: 12, borderRadius: 8, background: "rgba(255,255,255,0.04)" }}>
                                    <div style={{ color: "#e5e7eb", fontWeight: 700, marginBottom: 7 }}>{section.title}</div>
                                    {section.lines.map((line, lineIndex) => (
                                        <div key={lineIndex} style={{ color: line.includes("미통과") ? "#fb923c" : "#9ca3af", fontSize: 13, lineHeight: 1.65, wordBreak: "keep-all" }}>{line}</div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    )}
                </SettingCard>
            ))}
        </AppLayout>
    );
}

export default Stock;
